module.exports = __webpack_public_path__ + "img/follaje-w.848311fb.jpg";